// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	margin: 0;
	font-family: 'Inter', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

code {
	font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
		monospace;
}

.ant-btn-icon {
	margin-bottom: 0.4vh;
}

.input-group-text {
	background-color: white;
	cursor: pointer;
	color: #4e4e4e;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
}

.form-check-input:checked {
	background-color: #225fb0;
	border-color: #225fb0;
}

.form-check-label {
	color: #4e4e4e;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 20px;
}

.mb-05 {
	margin-bottom: 0.15rem !important;
}

svg {
	vertical-align: baseline;
}

body.modal-open> :not(.modal) {
	/*filter: blur(3px);*/
}

.cursor-pinter {
	cursor: pointer;
}

.bd-4 {
	border-radius: 4px;
}

.ant-pagination .ant-pagination-item {
	font-family: 'Inter', sans-serif !important;
}

.w-30 {
	width: 30%;
}

.w-60 {
	width: 60%;
}

.w-70 {
	width: 70%;
}

.text-red {
	color: #a5492d;
}

.w-25 {
	width: 25%;
}

.w-10 {
	width: 10%;
}

.w-15 {
	width: 15%;
}

.w-20 {
	width: 20%;
}

.w-25 {
	width: 25%;
}

.w-30 {
	width: 30%;
}

.w-40 {
	width: 40%;
}

.w-95 {
	width: 95%;
}

.bg-danger-100 {
	background-color: #eaa2a4;
}

.bg-danger-66 {
	background-color: #efbabc;
}

.bg-danger-33 {
	background-color: #f5d4d5;
}

.bg-neutral {
	background-color: #d9d9d9;
}

.bg-success-100 {
	background-color: #a6d0a6;
}

.bg-success-66 {
	background-color: #bddbbd;
}

.bg-success-33 {
	background-color: #cde3cd;
}

.bg-blue-33 {
	background-color: #ceedf8;
}

.rounded-left-only {
	border-radius: 4px 0 0 4px;
}

.rounded-right-only {
	border-radius: 0 4px 4px 0;
}

.table-striped>tbody>tr:nth-child(odd)>td,
.table-striped>tbody>tr:nth-child(odd)>th {
	background-color: #f5f5f5;
}

.ant-picker-input>input {
	font-size: 10px !important;
	font-weight: 600;
}

.text-green {
	color: #107c10;
}

.text-red {
	color: #d13438;
}

.text-neutral {
	color: #4e4e4e;
}

.ant-collapse>.ant-collapse-item>.ant-collapse-header {
	padding: 0;
}

.fs-24 {
	font-size: 24px !important;
}

.fs-20 {
	font-size: 20px !important;
}

.fs-10 {
	font-size: 10px;
}

.fs-12 {
	font-size: 12px !important;
}

.fs-14 {
	font-size: 14px !important;
}

.fs-16 {
	font-size: 16px !important;
}

.bg-blue {
	background-color: #dfedf7;
}

.fw-600 {
	font-weight: 600;
}

.bg-lightgrey {
	background-color: #f5f5f5;
}

.bg-orange {
	background-color: #d47645;
}

.bg-lightblue {
	background-color: #e0ecfc;
}

.bg-darkblue {
	background-color: #1f78b4;
}

.text-darkblue {
	color: #1f78b4;
}

.bg-danger-pink {
	background-color: #ffdfdf;
}

.bg-darkerblue {
	background-color: #225FB0;
}

.scrolling-wrapper {
	overflow-y: hidden;
	white-space: nowrap;
}

.table-scrollable {
	overflow-x: auto;
	width: 100%;
}

.tooltip-line {
	display: flex;
	gap: 1.5vw;
	justify-content: center;

	border-radius: 4px;
	border: 1px solid #225fb0;
	background: #fff;
	padding: 8px;
	font-size: 10px;
}

.cursor-pointer {
	cursor: pointer;
}

.h-23 {
	height: 23%;
}

.fw-400 {
	font-weight: 400;
}

.px-20 {
	padding-right: 20px;
	padding-left: 20px;
}

.fw-700 {
	font-weight: 700;
}

.mb-15 {
	margin-bottom: 15px;
}

.mt-15 {
	margin-top: 15px;
}

.bg-grey {
	background-color: #dcdfe7;
}

.disabled-dropdown {
	background-color: #dcdcdc;
	color: #b1b1b1;
}

.hover-white:hover {
	background-color: white;
	color: #225FB0 !important;
	border: 1px solid #225FB0;
}

.hover-blue:hover {
	background-color: #e0ecfc;
	/*cursor: pointer;*/
}

.table-fixed {
	table-layout: fixed;
	padding: 0.1vw;
}

.company-stock-code {
	border-radius: 4px;
	background: #225fb0;
	padding: 4px 8px;
	color: #fff;
}

.standard-code {
	border-radius: 4px;
	padding: 4px 8px;
}

.standard-padding {
	padding: 4px 8px;
}

.mh-100 {
	min-height: 100% !important;
}

.trim-text {
	white-space: nowrap;
	overflow: hidden;
	/*text-overflow: ellipsis;*/
}

.row-selected {
	background-color: #e0ecfc;
}

.cursor-none {
	cursor: not-allowed;
}

.border-darkblue {
	border: 1px solid #1f78b4;
}

.ant-select-selector {
	border-radius: 4px;
	background-color: #e0ecfc !important;
	border: none !important;
}

.ant-select-selection-item {
	color: #000;
	font-style: normal;
	line-height: normal;
	font-family: 'Inter', sans-serif !important;
}

.line {
	fill: none;
	stroke: #ffab00;
	stroke-width: 1.5;
}

.ant-select-selector {
	background-color: #f5f5f5 !important;
}

.ant-select-selection-placeholder {
	color: #4e4e4e !important;
	font-weight: 500;
}

.multi-line-tooltip {
	border-radius: 4px;
	border: 1px solid #225fb0;
	background: #fff;
}

.swipe-effect-right {
	animation: slideRight 0.3s forwards;
}

@keyframes slideRight {
	0% {
		transform: translateX(900px);
	}

	100% {
		transform: translateX(0);
	}
}

.list-data {
	border-bottom: 1px solid #E0E0E0;
	border-top: 1px solid #E0E0E0;
}

.table-hover-blue:hover>td {
	background-color: #e0ecfc !important;
	cursor: pointer;
}

.swipe-effect-left {
	animation: slideLeft 0.3s forwards;
}

@keyframes slideLeft {
	0% {
		transform: translateX(-900px);
	}

	100% {
		transform: translateX(0);
	}
}

.margin-right-2 {
	margin-right: 2px;
}

.margin-right-8 {
	margin-right: 8px;
}

.margin-left-2 {
	margin-left: 2px;
}

.margin-top-8 {
	margin-top: 8px;
}

.margin-top-2 {
	margin-top: 2px;
}

.margin-left-8 {
	margin-left: 8px;
}

.margin-top-4 {
	margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;CACC,SAAS;CACT,gCAAgC;CAChC,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC;WACU;AACX;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,uBAAuB;CACvB,eAAe;CACf,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,UAAU;CACV,uBAAuB;;CAEvB,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,uBAAuB;CACvB,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,oCAAoC;CACpC,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,2CAA2C;AAC5C;;AAEA;CACC,UAAU;CACV,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CAGC,mCAAmC;AACpC;;AAsBA;CACC;EACC,4BAA4B;CAC7B;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC,gCAAgC;CAChC,6BAA6B;AAC9B;;AAEA;CACC,oCAAoC;CACpC,eAAe;AAChB;;AAEA;CAGC,kCAAkC;AACnC;;AAsBA;CACC;EACC,6BAA6B;CAC9B;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\nbody {\n\tmargin: 0;\n\tfont-family: 'Inter', sans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n\t\tmonospace;\n}\n\n.ant-btn-icon {\n\tmargin-bottom: 0.4vh;\n}\n\n.input-group-text {\n\tbackground-color: white;\n\tcursor: pointer;\n\tcolor: #4e4e4e;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 600;\n}\n\n.form-check-input:checked {\n\tbackground-color: #225fb0;\n\tborder-color: #225fb0;\n}\n\n.form-check-label {\n\tcolor: #4e4e4e;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 20px;\n}\n\n.mb-05 {\n\tmargin-bottom: 0.15rem !important;\n}\n\nsvg {\n\tvertical-align: baseline;\n}\n\nbody.modal-open> :not(.modal) {\n\t/*filter: blur(3px);*/\n}\n\n.cursor-pinter {\n\tcursor: pointer;\n}\n\n.bd-4 {\n\tborder-radius: 4px;\n}\n\n.ant-pagination .ant-pagination-item {\n\tfont-family: 'Inter', sans-serif !important;\n}\n\n.w-30 {\n\twidth: 30%;\n}\n\n.w-60 {\n\twidth: 60%;\n}\n\n.w-70 {\n\twidth: 70%;\n}\n\n.text-red {\n\tcolor: #a5492d;\n}\n\n.w-25 {\n\twidth: 25%;\n}\n\n.w-10 {\n\twidth: 10%;\n}\n\n.w-15 {\n\twidth: 15%;\n}\n\n.w-20 {\n\twidth: 20%;\n}\n\n.w-25 {\n\twidth: 25%;\n}\n\n.w-30 {\n\twidth: 30%;\n}\n\n.w-40 {\n\twidth: 40%;\n}\n\n.w-95 {\n\twidth: 95%;\n}\n\n.bg-danger-100 {\n\tbackground-color: #eaa2a4;\n}\n\n.bg-danger-66 {\n\tbackground-color: #efbabc;\n}\n\n.bg-danger-33 {\n\tbackground-color: #f5d4d5;\n}\n\n.bg-neutral {\n\tbackground-color: #d9d9d9;\n}\n\n.bg-success-100 {\n\tbackground-color: #a6d0a6;\n}\n\n.bg-success-66 {\n\tbackground-color: #bddbbd;\n}\n\n.bg-success-33 {\n\tbackground-color: #cde3cd;\n}\n\n.bg-blue-33 {\n\tbackground-color: #ceedf8;\n}\n\n.rounded-left-only {\n\tborder-radius: 4px 0 0 4px;\n}\n\n.rounded-right-only {\n\tborder-radius: 0 4px 4px 0;\n}\n\n.table-striped>tbody>tr:nth-child(odd)>td,\n.table-striped>tbody>tr:nth-child(odd)>th {\n\tbackground-color: #f5f5f5;\n}\n\n.ant-picker-input>input {\n\tfont-size: 10px !important;\n\tfont-weight: 600;\n}\n\n.text-green {\n\tcolor: #107c10;\n}\n\n.text-red {\n\tcolor: #d13438;\n}\n\n.text-neutral {\n\tcolor: #4e4e4e;\n}\n\n.ant-collapse>.ant-collapse-item>.ant-collapse-header {\n\tpadding: 0;\n}\n\n.fs-24 {\n\tfont-size: 24px !important;\n}\n\n.fs-20 {\n\tfont-size: 20px !important;\n}\n\n.fs-10 {\n\tfont-size: 10px;\n}\n\n.fs-12 {\n\tfont-size: 12px !important;\n}\n\n.fs-14 {\n\tfont-size: 14px !important;\n}\n\n.fs-16 {\n\tfont-size: 16px !important;\n}\n\n.bg-blue {\n\tbackground-color: #dfedf7;\n}\n\n.fw-600 {\n\tfont-weight: 600;\n}\n\n.bg-lightgrey {\n\tbackground-color: #f5f5f5;\n}\n\n.bg-orange {\n\tbackground-color: #d47645;\n}\n\n.bg-lightblue {\n\tbackground-color: #e0ecfc;\n}\n\n.bg-darkblue {\n\tbackground-color: #1f78b4;\n}\n\n.text-darkblue {\n\tcolor: #1f78b4;\n}\n\n.bg-danger-pink {\n\tbackground-color: #ffdfdf;\n}\n\n.bg-darkerblue {\n\tbackground-color: #225FB0;\n}\n\n.scrolling-wrapper {\n\toverflow-y: hidden;\n\twhite-space: nowrap;\n}\n\n.table-scrollable {\n\toverflow-x: auto;\n\twidth: 100%;\n}\n\n.tooltip-line {\n\tdisplay: flex;\n\tgap: 1.5vw;\n\tjustify-content: center;\n\n\tborder-radius: 4px;\n\tborder: 1px solid #225fb0;\n\tbackground: #fff;\n\tpadding: 8px;\n\tfont-size: 10px;\n}\n\n.cursor-pointer {\n\tcursor: pointer;\n}\n\n.h-23 {\n\theight: 23%;\n}\n\n.fw-400 {\n\tfont-weight: 400;\n}\n\n.px-20 {\n\tpadding-right: 20px;\n\tpadding-left: 20px;\n}\n\n.fw-700 {\n\tfont-weight: 700;\n}\n\n.mb-15 {\n\tmargin-bottom: 15px;\n}\n\n.mt-15 {\n\tmargin-top: 15px;\n}\n\n.bg-grey {\n\tbackground-color: #dcdfe7;\n}\n\n.disabled-dropdown {\n\tbackground-color: #dcdcdc;\n\tcolor: #b1b1b1;\n}\n\n.hover-white:hover {\n\tbackground-color: white;\n\tcolor: #225FB0 !important;\n\tborder: 1px solid #225FB0;\n}\n\n.hover-blue:hover {\n\tbackground-color: #e0ecfc;\n\t/*cursor: pointer;*/\n}\n\n.table-fixed {\n\ttable-layout: fixed;\n\tpadding: 0.1vw;\n}\n\n.company-stock-code {\n\tborder-radius: 4px;\n\tbackground: #225fb0;\n\tpadding: 4px 8px;\n\tcolor: #fff;\n}\n\n.standard-code {\n\tborder-radius: 4px;\n\tpadding: 4px 8px;\n}\n\n.standard-padding {\n\tpadding: 4px 8px;\n}\n\n.mh-100 {\n\tmin-height: 100% !important;\n}\n\n.trim-text {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\t/*text-overflow: ellipsis;*/\n}\n\n.row-selected {\n\tbackground-color: #e0ecfc;\n}\n\n.cursor-none {\n\tcursor: not-allowed;\n}\n\n.border-darkblue {\n\tborder: 1px solid #1f78b4;\n}\n\n.ant-select-selector {\n\tborder-radius: 4px;\n\tbackground-color: #e0ecfc !important;\n\tborder: none !important;\n}\n\n.ant-select-selection-item {\n\tcolor: #000;\n\tfont-style: normal;\n\tline-height: normal;\n\tfont-family: 'Inter', sans-serif !important;\n}\n\n.line {\n\tfill: none;\n\tstroke: #ffab00;\n\tstroke-width: 1.5;\n}\n\n.ant-select-selector {\n\tbackground-color: #f5f5f5 !important;\n}\n\n.ant-select-selection-placeholder {\n\tcolor: #4e4e4e !important;\n\tfont-weight: 500;\n}\n\n.multi-line-tooltip {\n\tborder-radius: 4px;\n\tborder: 1px solid #225fb0;\n\tbackground: #fff;\n}\n\n.swipe-effect-right {\n\t-webkit-animation: slideRight 0.3s forwards;\n\t-moz-animation: slideRight 0.3s forwards;\n\tanimation: slideRight 0.3s forwards;\n}\n\n@-webkit-keyframes slideRight {\n\t0% {\n\t\ttransform: translateX(900px);\n\t}\n\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n@-moz-keyframes slideRight {\n\t0% {\n\t\ttransform: translateX(900px);\n\t}\n\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n@keyframes slideRight {\n\t0% {\n\t\ttransform: translateX(900px);\n\t}\n\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n.list-data {\n\tborder-bottom: 1px solid #E0E0E0;\n\tborder-top: 1px solid #E0E0E0;\n}\n\n.table-hover-blue:hover>td {\n\tbackground-color: #e0ecfc !important;\n\tcursor: pointer;\n}\n\n.swipe-effect-left {\n\t-webkit-animation: slideLeft 0.3s forwards;\n\t-moz-animation: slideLeft 0.3s forwards;\n\tanimation: slideLeft 0.3s forwards;\n}\n\n@-webkit-keyframes slideLeft {\n\t0% {\n\t\ttransform: translateX(-900px);\n\t}\n\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n@-moz-keyframes slideLeft {\n\t0% {\n\t\ttransform: translateX(-900px);\n\t}\n\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n@keyframes slideLeft {\n\t0% {\n\t\ttransform: translateX(-900px);\n\t}\n\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n.margin-right-2 {\n\tmargin-right: 2px;\n}\n\n.margin-right-8 {\n\tmargin-right: 8px;\n}\n\n.margin-left-2 {\n\tmargin-left: 2px;\n}\n\n.margin-top-8 {\n\tmargin-top: 8px;\n}\n\n.margin-top-2 {\n\tmargin-top: 2px;\n}\n\n.margin-left-8 {\n\tmargin-left: 8px;\n}\n\n.margin-top-4 {\n\tmargin-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
